
function AdventPolicyFr() {
  return (<div className="container">


    <h2><span className="App-title">Politique de Confidentialité</span></h2>
    <h2>1. Introduction</h2>
    <p>Nous attachons une grande importance à la protection de vos données personnelles. Cette politique de confidentialité explique comment <em>Calendrier de l'Advent</em> collecte, utilise, stocke et protège vos informations lorsque vous utilisez notre application de calendrier de l’Avent partagé (ci-après « l'Application »).</p>

    <p>En utilisant l’Application, vous acceptez les pratiques décrites dans cette politique de confidentialité. Si vous avez des questions, veuillez nous contacter à <em>tryciaspas@gmail.com</em>.</p>

    <h2>2. Données collectées</h2>
    <p>Pas de collection de données.<br />
    </p>
    <h2>3. Utilisation des données</h2>
    <p>Pas d'utilisation d</p>

    <h2>4. Vos droits</h2>
    <p>Conformément au RGPD (si applicable) et à d'autres lois en vigueur, vous disposez des droits suivants :

      Accès : Consultez les données personnelles que nous détenons sur vous.<br />
      Rectification : Corrigez vos informations inexactes.<br />
      Suppression : Demandez la suppression de vos données.<br />
      Portabilité : Recevez vos données dans un format structuré.<br />
      Opposition : Refusez l’utilisation de vos données pour certaines finalités.<br />
      Pour exercer ces droits, contactez-nous à tryciaspas at gmail dot com.<br /></p>

    <h2>5. Cookies et technologies similaires</h2>
    <p>L’Application peut utiliser des cookies ou des technologies similaires pour collecter des informations sur votre utilisation et améliorer votre expérience. Vous pouvez gérer vos préférences en matière de cookies via les paramètres de votre appareil.</p>

    <h2>6. Modifications de cette politique</h2>
    <p>Nous pouvons mettre à jour cette politique de confidentialité de temps en temps. Les modifications seront publiées dans l’Application et vous serez informé en cas de mise à jour majeure.</p>

    <h2>7. Contact</h2>
    <p>Pour toute question ou demande concernant cette politique de confidentialité, vous pouvez nous contacter à l’adresse suivante :</p>

    <p>Email: tryciaspas at gmail dot com</p>

  </div>);
}
export default AdventPolicyFr;
